import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DatatableClickEvent } from '@basis/angular-components';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { SelectItem } from 'primeng/primeng';
import { BaseStepComponent } from "../../../base/base-step.component";
import { Sistema } from '../../../entity/sistema.model';

@Component({
  selector: 'modulos-sistema',
  template:`
  <div *ngFor="let sistema of sistemas">
    teste
  </div>
  `
})

export class CrudModulosSistemaComponent {
  @Input() sistemas: Sistema[];
}


// WEBPACK FOOTER //
// ./src/app/modulos/crud/etapas/modulo-sistema.component.ts